import React from 'react';
import unpin from '../../../../assets/img/svg/colum-order/unpin.svg';
import pin from '../../../../assets/img/svg/colum-order/pin.svg';
import { Column } from '../../../../enum/Column';
import { t } from 'i18next';

interface GeoSummaryRowOptionsProps {
  index: number;
  column: Column;
  isSelected: boolean;
  onSelect: () => void;
  disabled?: boolean;
  onPinToggle: () => void;
}

const GeoSummaryRowOptions: React.FC<GeoSummaryRowOptionsProps> = ({
  index,
  column,
  isSelected,
  onSelect,
  disabled = false,
  onPinToggle,
}) => {
  return (
    <div className="options_list" key={index}>
      <img className="pin_icon" src={column.isPinned ? pin : unpin} alt={'Pinned'} onClick={onPinToggle} />

      <div
        className={`option_checkbox ${disabled ? 'disabled' : ''}`}
        onClick={() => {
          if (disabled) return;
          onSelect();
        }}
      >
        <input type="checkbox" checked={isSelected} disabled={disabled} onChange={() => {}} name="geo_summary_input" />

        <div className="option">
          <span> {t(`columns.${column.name}`)}</span>
        </div>
      </div>
    </div>
  );
};

export default GeoSummaryRowOptions;
